/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ClientBillingCustomProductMapping } from '../models/client-billing-custom-product-mapping';
import { AcceptedResponseBody } from '../models/accepted-response-body';
@Injectable({
  providedIn: 'root',
})
class CustomProductMappingService extends __BaseService {
  static readonly GetAllForClientPath = '/customproductmapping/{aviClientId}';
  static readonly UpdateCustomProductPath = '/customproductmapping';
  static readonly CreateCustomProductPath = '/customproductmapping';
  static readonly DeletePath = '/customproductmapping';
  static readonly GetAvailableSourceFieldsPath = '/customproductmapping/GetAvailableSourceFields';
  static readonly GetAvailablesConditionalFieldsPath = '/customproductmapping/GetAvailableConditionalFields';
  static readonly GetAvailableProductTypesPath = '/customproductmapping/GetAvailableProductTypes';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `CustomProductMappingService.GetAllForClientParams` containing the following parameters:
   *
   * - `aviClientId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  GetAllForClientResponse(params: CustomProductMappingService.GetAllForClientParams): __Observable<__StrictHttpResponse<Array<ClientBillingCustomProductMapping>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/customproductmapping/${params.aviClientId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ClientBillingCustomProductMapping>>;
      })
    );
  }
  /**
   * @param params The `CustomProductMappingService.GetAllForClientParams` containing the following parameters:
   *
   * - `aviClientId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  GetAllForClient(params: CustomProductMappingService.GetAllForClientParams): __Observable<Array<ClientBillingCustomProductMapping>> {
    return this.GetAllForClientResponse(params).pipe(
      __map(_r => _r.body as Array<ClientBillingCustomProductMapping>)
    );
  }

  /**
   * @param params The `CustomProductMappingService.UpdateCustomProductParams` containing the following parameters:
   *
   * - `value`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  UpdateCustomProductResponse(params: CustomProductMappingService.UpdateCustomProductParams): __Observable<__StrictHttpResponse<AcceptedResponseBody>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.value;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/customproductmapping`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AcceptedResponseBody>;
      })
    );
  }
  /**
   * @param params The `CustomProductMappingService.UpdateCustomProductParams` containing the following parameters:
   *
   * - `value`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  UpdateCustomProduct(params: CustomProductMappingService.UpdateCustomProductParams): __Observable<AcceptedResponseBody> {
    return this.UpdateCustomProductResponse(params).pipe(
      __map(_r => _r.body as AcceptedResponseBody)
    );
  }

  /**
   * @param params The `CustomProductMappingService.CreateCustomProductParams` containing the following parameters:
   *
   * - `value`:
   *
   * - `Authorization`: Bearer token
   */
  CreateCustomProductResponse(params: CustomProductMappingService.CreateCustomProductParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.value;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/customproductmapping`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `CustomProductMappingService.CreateCustomProductParams` containing the following parameters:
   *
   * - `value`:
   *
   * - `Authorization`: Bearer token
   */
  CreateCustomProduct(params: CustomProductMappingService.CreateCustomProductParams): __Observable<null> {
    return this.CreateCustomProductResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `CustomProductMappingService.DeleteParams` containing the following parameters:
   *
   * - `value`:
   *
   * - `Authorization`: Bearer token
   */
  DeleteResponse(params: CustomProductMappingService.DeleteParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.value;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/customproductmapping`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `CustomProductMappingService.DeleteParams` containing the following parameters:
   *
   * - `value`:
   *
   * - `Authorization`: Bearer token
   */
  Delete(params: CustomProductMappingService.DeleteParams): __Observable<null> {
    return this.DeleteResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `CustomProductMappingService.GetAvailableSourceFieldsParams` containing the following parameters:
   *
   * - `clientId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  GetAvailableSourceFieldsResponse(params: CustomProductMappingService.GetAvailableSourceFieldsParams): __Observable<__StrictHttpResponse<{[key: string]: string}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.clientId != null) __params = __params.set('clientId', params.clientId.toString());
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/customproductmapping/GetAvailableSourceFields`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{[key: string]: string}>;
      })
    );
  }
  /**
   * @param params The `CustomProductMappingService.GetAvailableSourceFieldsParams` containing the following parameters:
   *
   * - `clientId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  GetAvailableSourceFields(params: CustomProductMappingService.GetAvailableSourceFieldsParams): __Observable<{[key: string]: string}> {
    return this.GetAvailableSourceFieldsResponse(params).pipe(
      __map(_r => _r.body as {[key: string]: string})
    );
  }

  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetAvailablesConditionalFieldsResponse(Authorization?: string): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/customproductmapping/GetAvailableConditionalFields`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      })
    );
  }
  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetAvailablesConditionalFields(Authorization?: string): __Observable<Array<string>> {
    return this.GetAvailablesConditionalFieldsResponse(Authorization).pipe(
      __map(_r => _r.body as Array<string>)
    );
  }

  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetAvailableProductTypesResponse(Authorization?: string): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/customproductmapping/GetAvailableProductTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      })
    );
  }
  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetAvailableProductTypes(Authorization?: string): __Observable<Array<string>> {
    return this.GetAvailableProductTypesResponse(Authorization).pipe(
      __map(_r => _r.body as Array<string>)
    );
  }
}

module CustomProductMappingService {

  /**
   * Parameters for GetAllForClient
   */
  export interface GetAllForClientParams {
    aviClientId: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for UpdateCustomProduct
   */
  export interface UpdateCustomProductParams {
    value?: ClientBillingCustomProductMapping;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for CreateCustomProduct
   */
  export interface CreateCustomProductParams {
    value?: ClientBillingCustomProductMapping;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for Delete
   */
  export interface DeleteParams {
    value?: ClientBillingCustomProductMapping;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for GetAvailableSourceFields
   */
  export interface GetAvailableSourceFieldsParams {
    clientId?: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }
}

export { CustomProductMappingService }
